import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form } from "../../styles";
import AuthWrapper from "../../layout/AuthWrapper";
import { useAuthContext } from "../../context/auth_context";
import MiniLoader from "../../utils/MIniLoader";
import { useUserContext } from "../../context/user_context";
import CustomSelect from "../../utils/CustomSelect";
import { round } from "../../assets";
import ProtectUser from "../../app/protectUser";

function SetProfile() {

  const [issending, setissending] = useState(false);
  const [stoken, setstoken] = useState('');
  const [btoken, setbtoken] = useState('');
  const [display, setdisplay] = useState(false);


  let navigate = useNavigate();
  const {
    getBiz: { getAllBusiness, allBusiness, bizLoad, getBusinessData, businessData },
    getStore: { getAllStore, allStores, storeLoad },
    getFeature: { getFeatureAccess, featureAccess },
  } = useAuthContext();

  const { userData } = useUserContext();

  // Set Biz and Update Store

  function setbiztoken(e) {
    setbtoken(e);
    loadStores(e);
  }
  function loadStores(e) {
    getAllStore(e);
    setdisplay(true);
  }
  // Set Biz and Update Store

  //   Gain Access Function
  function gainAccess(e) {
    e.preventDefault();
    setissending(true);
    if (btoken === '') {
      setissending(false);
      toast.error("Select a Business!");
    } else {
      if (stoken === '') {
        setissending(false);
        toast.error("Select a Store!");
      } else {
        setTimeout(() => {
          setissending(false);
          if (localStorage.getItem('active') === '0') {
            navigate("/user/settings/noAccess");
            // setTimeout(() => {
            //   toast.warn('This Business is Inactive...');
            // }, 10);
          } else {
            if (featureAccess) {
              navigate("/user/dashboard");
              setTimeout(() => {
                toast.success('Welcome back...');
              }, 10);
            }
          }
        }, 2000);
      }
    }
  }
  //   Gain Access Function

  //  Get Business Details Function
  useEffect(() => {
    btoken && getBusinessData(btoken);
  }, [btoken]);
  //  Get Business Details Function

  //  Get All Business

  useEffect(() => {
    getAllBusiness();
  }, []);

  const business = allBusiness.map(({ name, btoken }) => {
    return (
      { label: name, value: btoken }
    );
  });

  //  Get All Business

  //  Get All Store

  const stores = allStores.map(({ storename, token }) => {
    return (
      { label: storename, value: token }
    );
  });

  //  Get All Store

  // For Those without a store and account is inactive
  // function toDashboard() {
  //   if (btoken) {
  //     getbizData()
  //     localStorage.setItem('btoken', btoken)
  //     setTimeout(() => {
  //       history.push('/dasboard')
  //     }, 1000);
  //   }else{
  //     toast.error("Select a Business!");
  //   }
  // }
  // For Those without a store and account is inactive

  return (
    <ProtectUser>
      <AuthWrapper
        title={`Welcome Back, ${ userData?.fname }`}
        subTitle='Select the Business and Store you want to access, Let’s get you into your RENI account.'
        img={round}
      >

        <Form>
          <div className="row justify-content-center text-start">

            {bizLoad && <> <MiniLoader load={bizLoad} /> loading business(es) </>}

            <div className="col-md-12 ">
              <label className="mb-0"> Business:</label>
              <CustomSelect
                options={business}
                isSearchable={true}
                onChange={(e) => setbiztoken(e.value)}
                placeholder='Select Business'
                required
              />
            </div>
            {storeLoad && <> <MiniLoader load={storeLoad} /> loading store(s) </>}
            <div className={`col-md-12 ${ display ? 'd-block' : 'd-none' }`}>
              <label className="mb-0"> Store:</label>
              <CustomSelect
                options={stores}
                isSearchable={true}
                onChange={(e) => getFeatureAccess(e.value, btoken, setstoken)}
                placeholder='Select Store'
                required
              />
            </div>

            <div className="col-md-12 mx-auto text-center">
              <div className="user-btn mb-4 mr-auto text-center">

                <Button
                  pry
                  type="submit"
                  className="btn m-0 w-100"
                  onClick={(e) => gainAccess(e)}
                  disabled={issending}
                >
                  {issending ? 'loading...' : 'Submit'}
                </Button>

              </div>

              <hr className="m-2" />
              <div className="text-center">
                <small>
                  Don't have a Business
                  <span >
                    <Link to="/create-business" className="pry-text"> Create it here</Link>
                  </span>
                  .
                </small>
              </div>
              {/* <div className="text-center">
                      <small>
                        Don't have a Store
                        <span className="pry-text ml-1"
                        onClick={e=>toDashboard()}
                        >
                        Dashboard 
                        </span>
                        .
                      </small>
                    </div> */}
            </div>
          </div>
        </Form>

      </AuthWrapper>

    </ProtectUser>
  );
}

export default SetProfile;
